import React from 'react';
import listIcon from '../../../../assets/images/list_view.svg';
import blockIcon from '../../../../assets/images/block_view.svg';

const ViewFiltersDesktop = ({ toggleTimeView, toggleListView, isListView, isLiveView, isAdmin }) => (
    <React.Fragment>
        {!isAdmin && (
            <ul className="ckp-timetable-actions-group rp-hidden-1200-min">
                <li
                    onClick={!isLiveView ? toggleTimeView : null}
                    className={`ckp-timetable-actions-option ${isLiveView ? 'is-selected' : ''}`}
                >
                    Live View
                </li>
                <li
                    onClick={isLiveView ? toggleTimeView : null}
                    className={`ckp-timetable-actions-option ${isLiveView ? '' : 'is-selected'}`}
                >
                    Post Event View
                </li>
            </ul>
        )}
        <ul className={`ckp-timetable-actions-group ${isAdmin ? 'is-not-responsive' : 'rp-hidden-1200-min'}`}>
            <li
                onClick={isListView ? toggleListView : null}
                className={`ckp-timetable-actions-option ${isListView ? '' : 'is-selected'}`}
            >
                <img src={blockIcon} alt="Timetable view" />
            </li>
            <li
                onClick={!isListView ? toggleListView : null}
                className={`ckp-timetable-actions-option ${isListView ? 'is-selected' : ''}`}
            >
                <img src={listIcon} alt="List view" />
            </li>
        </ul>
    </React.Fragment>
);

export default ViewFiltersDesktop;
